const grade_constant = {
	//积分商品类型
	GOODS_TYPE: [
		{ name: 'PHYSICAL', label: '实物' },
		{ name: 'TICKET', label: '卡券' }
	],
	//卡券类型
	COUPON_TYPE: [
		{ name: 'FULL_REDUCTION', label: '满减券', type: '卡券' },
		{ name: 'DISCOUNT', label: '折扣券', type: '卡券' },
		{ name: 'CONSUME', label: '消费券', type: '卡券' },
		{ name: 'GIFT_CARD', label: '礼品卡', type: '卡券' },
		{ name: 'GIFT', label: '礼品', type: '实物' },
		{ name: 'PARKING', label: '停车券', type: '卡券' }
	]
};
export default grade_constant;
export const GOODS_TYPE = grade_constant.GOODS_TYPE;
export const COUPON_TYPE = grade_constant.COUPON_TYPE;
